import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import SalaryDetail from "./components/SalaryDetail";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/salary/:id" element={<SalaryDetail />} />
          {/* Add other routes here if needed */}
          <Route
            path="/"
            element={
              <div>
                <h1>Chào mừng đến với hệ thống bảng lương</h1>
                <p>
                  Vui lòng truy cập /salary/&lt;id&gt; để xem chi tiết bảng
                  lương.
                </p>
              </div>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
